import React, { useMemo } from 'react';
import { HALLOWEEN_MSG_KEY } from '../../utils/halloweenMsg';
import './ThankYouPage.css';

export default function ThankYouPage() {
  const message = useMemo(() => {
    try {
      return sessionStorage.getItem(HALLOWEEN_MSG_KEY) || 'Thanks for playing!';
    } catch {
      return 'Thanks for playing!';
    }
  }, []);

  return (
    <div className="thankyou-page">
      <img
        src="/img/halloween/thankyou.gif"
        alt="Thank you"
        className="thankyou-img thankyou-logo"
      />
      <div className="thankyou-score score">{message}</div>
    </div>
  );
}
